module.exports = __webpack_public_path__ + "LV.png?7ceac7914024912b3ee343bed5f7fdbc";